import React, { useEffect, useState } from "react";
import Footer from "./components/Footer";
import HeroSection from "./components/HeroSection";
import InfoSection from "./components/InfoSection";
import ItinerarySection from "./components/ItinerarySection";
import FAQSection from "./components/FAQSection";
import RSVPForm from "./components/RSVPForm";
import Navbar from "./components/Navbar";
import { SITE_PW_HASH, SITE_PW_PLAIN, SITE_STORAGE_KEY } from "./config";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const sha256 = async (value) => {
  const msgUint8 = new TextEncoder().encode(value);
  const hashBuffer = await window.crypto.subtle.digest("SHA-256", msgUint8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
};

export default function App() {
  const [unlocked, setUnlocked] = useState(false);
  const [loading, setLoading] = useState(true);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(SITE_STORAGE_KEY);
    if (saved === "true") {
      setUnlocked(true);
      setLoading(false);
      return;
    }
    if (!SITE_PW_HASH && !SITE_PW_PLAIN) {
      console.error(
        "No pw configured. Set REACT_APP_SITE_PW or REACT_APP_SITE_PW_HASH in .env"
      );
    }
    setLoading(false);
  }, []);

  const validatePassword = async (value) => {
    if (SITE_PW_PLAIN && value === SITE_PW_PLAIN) {
      return true;
    }
    if (!SITE_PW_HASH) {
      return false;
    }
    const hash = await sha256(value);
    return hash === SITE_PW_HASH;
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setError("");
    if (!password) {
      setError("Please enter the guest code");
      return;
    }

    const ok = await validatePassword(password.trim());
    if (ok) {
      localStorage.setItem(SITE_STORAGE_KEY, "true");
      setUnlocked(true);
      setPassword("");
      setError("");
    } else {
      setError("Incorrect guest code. Try again.");
      setPassword("");
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 text-slate-800">
        Loading...
      </div>
    );
  }

  if (!unlocked) {
    return (
      <div
        className="min-h-screen w-full bg-cover bg-center flex items-center justify-center"
        style={{
          backgroundImage: "url('/Images/Welcome/temple_background.png')",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-amber-500/40 via-fuchsia-600/30 to-purple-700/40"></div>
        <div className="relative z-10 w-full max-w-md p-8 mx-2 rounded-2xl bg-white/85 shadow-2xl border border-amber-200">
          <h1 className="font-garamond small-caps text-4xl font-bold text-center mb-4 text-amber-800">Welcome</h1>
          <p className="text-center text-sm text-amber-700 mb-6">
            Please enter the guest code<br />to access the celebration details.
          </p>
          <form onSubmit={onSubmit}>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Guest Code"
                className="w-full px-4 py-3 pr-12 rounded-lg border border-amber-300 focus:outline-none focus:ring-2 focus:ring-amber-500 font-garamond"
              />

              <button
                type="button"
                onClick={() => setShowPassword((prev) => !prev)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-amber-600 hover:text-amber-800"
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
            {error && <p className="mt-2 text-red-600 text-sm">{error}</p>}
            <button
              type="submit"
              className="mt-6 w-full px-4 py-3 bg-gradient-to-r from-amber-500 to-purple-600 text-white font-garamond small-caps font-bold rounded-lg hover:scale-[1.01] transform transition"
            >
              Unlock
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="text-gray-800">
      <Navbar />
      <HeroSection />
      <InfoSection />
      <ItinerarySection />
      <FAQSection />
      <RSVPForm />
      <Footer />
    </div>
  );
}

